import { Middleware } from '@reduxjs/toolkit';

export const createMiddleware = (
  apiModules: any,
  customMiddleware: Middleware
) => {
  const middlewareArray: Middleware[] = [];

  // Set to track unique middleware to avoid duplicates
  const addedMiddleware = new Set();

  Object.keys(apiModules).forEach((key) => {
    if (
      apiModules[key]?.middleware &&
      !addedMiddleware.has(apiModules[key].middleware)
    ) {
      middlewareArray.push(apiModules[key].middleware);
      addedMiddleware.add(apiModules[key].middleware); // Mark as added
    }
  });

  // Add custom middleware
  middlewareArray.push(customMiddleware);

  return middlewareArray;
};
